// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.syntax-code {
    display: inline-block;
    width: fit-content;
    padding: 8px 16px;   /* Adds padding around the code */
    background-color: #f8f8f8; /* Light gray background */
    border-radius: 4px; /* Rounded corners */
    box-shadow: 0 1px 3px rgba(0,0,0,0.1); /* A light shadow for depth */
    font-family: 'Courier New', Courier, monospace; /* Suggested font for code */
    transition: background-color 0.3s, box-shadow 0.3s; /* Transition effects */
}

.syntax-code:hover {
    background-color: #e8e8e8; /* Darker gray on hover */
    box-shadow: 0 2px 6px rgba(0,0,0,0.15); /* A deeper shadow on hover */
}

.bullet-points {
    list-style-type: disc;
    margin-left: 1.5em;
    padding-left: 0;
}

.bullet-point {
    margin-bottom: 0.5em;
    transition: margin-left 0.2s; /* Transition for a slight move effect */
}

.bullet-point:hover {
    margin-left: 1em; /* Moves the bullet point slightly to the left on hover */
}

.leading-normal table {
    overflow-x: auto;
    margin-top: 10px;
    transition: box-shadow 0.3s; /* Transition for shadow */
}

.leading-normal table:hover {
    box-shadow: 0 2px 6px rgba(0,0,0,0.1); /* Adds a shadow to the table on hover */
}

.leading-normal table {
    border-collapse: collapse;
    width: 100%;
}

.leading-normal table th, table td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    transition: background-color 0.3s; /* Transition for hover effect */
}

.leading-normal table th {
    background-color: white;
    font-weight: bold;
}

.leading-normal table tr:hover td {
    background-color: #f5f5f5; /* Slight gray background for row on hover */
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components/code-syntax-highlighter/code-highlight.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB,IAAI,iCAAiC;IACtD,yBAAyB,EAAE,0BAA0B;IACrD,kBAAkB,EAAE,oBAAoB;IACxC,qCAAqC,EAAE,6BAA6B;IACpE,8CAA8C,EAAE,4BAA4B;IAC5E,kDAAkD,EAAE,uBAAuB;AAC/E;;AAEA;IACI,yBAAyB,EAAE,yBAAyB;IACpD,sCAAsC,EAAE,6BAA6B;AACzE;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,4BAA4B,EAAE,wCAAwC;AAC1E;;AAEA;IACI,gBAAgB,EAAE,yDAAyD;AAC/E;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B,EAAE,0BAA0B;AAC3D;;AAEA;IACI,qCAAqC,EAAE,wCAAwC;AACnF;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,iCAAiC,EAAE,gCAAgC;AACvE;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB,EAAE,4CAA4C;AAC3E","sourcesContent":[".syntax-code {\n    display: inline-block;\n    width: fit-content;\n    padding: 8px 16px;   /* Adds padding around the code */\n    background-color: #f8f8f8; /* Light gray background */\n    border-radius: 4px; /* Rounded corners */\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1); /* A light shadow for depth */\n    font-family: 'Courier New', Courier, monospace; /* Suggested font for code */\n    transition: background-color 0.3s, box-shadow 0.3s; /* Transition effects */\n}\n\n.syntax-code:hover {\n    background-color: #e8e8e8; /* Darker gray on hover */\n    box-shadow: 0 2px 6px rgba(0,0,0,0.15); /* A deeper shadow on hover */\n}\n\n.bullet-points {\n    list-style-type: disc;\n    margin-left: 1.5em;\n    padding-left: 0;\n}\n\n.bullet-point {\n    margin-bottom: 0.5em;\n    transition: margin-left 0.2s; /* Transition for a slight move effect */\n}\n\n.bullet-point:hover {\n    margin-left: 1em; /* Moves the bullet point slightly to the left on hover */\n}\n\n.leading-normal table {\n    overflow-x: auto;\n    margin-top: 10px;\n    transition: box-shadow 0.3s; /* Transition for shadow */\n}\n\n.leading-normal table:hover {\n    box-shadow: 0 2px 6px rgba(0,0,0,0.1); /* Adds a shadow to the table on hover */\n}\n\n.leading-normal table {\n    border-collapse: collapse;\n    width: 100%;\n}\n\n.leading-normal table th, table td {\n    padding: 8px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n    transition: background-color 0.3s; /* Transition for hover effect */\n}\n\n.leading-normal table th {\n    background-color: white;\n    font-weight: bold;\n}\n\n.leading-normal table tr:hover td {\n    background-color: #f5f5f5; /* Slight gray background for row on hover */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
